module.exports = __webpack_public_path__ + "media/src/assets/Images/FilterArrow-4c23274f998369b5e3196563fb6f16be.svg";